// id strings for messages/nav.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const nav: Dict = {
  "nav.home": "Beranda",
  "nav.create": "Buat",
  "nav.voices": "Suara",
  "nav.train": "Latih suara",
  "nav.library": "Pustaka",
  "nav.tab.profile": "Profil",
  "nav.404.seoTitle": "Halaman tidak ditemukan | Jammable",
  "nav.404.title": "Halaman tidak ditemukan!",
  "nav.404.body": "Sepertinya konten ini sudah tidak ada.",
  "nav.404.home": "Kembali ke beranda",
  "nav.404.browse": "Jelajahi suara",
  "nav.404.discordLabel": "Mencari sesuatu?",
  "nav.404.discordBody": "Tanya komunitas di Discord",
  "nav.pricing": "Harga",
  "nav.affiliate": "Program Afiliasi",
  "nav.api": "API",
  "nav.login": "Masuk",
  "nav.signup": "Daftar",
  "nav.signupFree": "Daftar gratis",
  "nav.getPlan": "Pilih paket",
  "nav.discordAria": "Gabung ke Discord Jammable",
  "nav.discordJoin": "Gabung ke Discord kami",
  "nav.openMenu": "Buka menu",
  "nav.closeMenu": "Tutup menu",

  "nav.greet.0.0": "Wah, bangun pagi nih",
  "nav.greet.0.1": "Selamat pagi",
  "nav.greet.0.2": "Halo",
  "nav.greet.0.3": "Hai",
  "nav.greet.0.4": "Apa kabar?",
  "nav.greet.1.0": "Yo",
  "nav.greet.1.1": "Hai",
  "nav.greet.1.2": "Halo",
  "nav.greet.1.3": "Gimana kabarnya?",
  "nav.greet.1.4": "Selamat siang",
  "nav.greet.2.0": "Selamat malam",
  "nav.greet.2.1": "Hai, kamu",
  "nav.greet.2.2": "Lagi ngapain?",
  "nav.greet.2.3": "Hai",
  "nav.greet.2.4": "Halo, halo",
  "nav.greet.3.0": "Masih melek?",
  "nav.greet.3.1": "Begadang, ya?",
  "nav.greet.3.2": "Yo, anak malam",
  "nav.greet.3.3": "Nggak bisa tidur?",
  "nav.greet.3.4": "Vibes tengah malam",
  "nav.profile.view": "Lihat profil",
  "nav.profile.credit": "kredit",
  "nav.profile.credits": "kredit",
  "nav.profile.voicePass": "voice pass",
  "nav.profile.voices": "suara",
  "nav.profile.shop": "Toko Item",
  "nav.profile.feedback": "Kirim Masukan",
  "nav.profile.settings": "Pengaturan",
  "nav.profile.apiDashboard": "Dasbor API",
  "nav.profile.signOut": "Keluar",
  "nav.profile.signedOut": "Berhasil keluar!",
  "nav.profile.avatarAlt": "foto profil",

  "nav.footer.tagline":
    "Cover AI dengan 100.000+ suara. Bikin dalam hitungan detik.",
  "nav.footer.colCreate": "Buat",
  "nav.footer.colAccount": "Akun",
  "nav.footer.colLegal": "Legal",
  "nav.footer.aiCover": "Pembuat Cover AI",
  "nav.footer.voiceChanger": "Pengubah Suara AI",
  "nav.footer.voiceLibrary": "Pustaka Suara AI",
  "nav.footer.train": "Latih Suara",
  "nav.footer.weights": "Alternatif Weights.gg",
  "nav.footer.settings": "Pengaturan",
  "nav.footer.earn": "Dapatkan Penghasilan dengan Jammable",
  "nav.footer.mcp": "Server MCP untuk Agen AI",
  "nav.footer.forgot": "Lupa kata sandi",
  "nav.footer.terms": "Ketentuan Penggunaan",
  "nav.footer.privacy": "Kebijakan Privasi",
  "nav.footer.dmca": "Kebijakan DMCA",
  "nav.footer.refunds": "Kebijakan Pengembalian Dana",
  "nav.footer.pitchmeldBefore": "Menggunakan",
  "nav.footer.pitchmeldLink": "teknologi Pitchmeld",
  "nav.footer.pitchmeldAfter": "untuk pemrosesan suara",

  "nav.language": "Bahasa",
};

export default nav;
